<template>
  <div style="background-color: #fff;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="淘宝天猫" name="first"><wrapperTable /></el-tab-pane>
    <el-tab-pane label="1688网" name="second">1688网</el-tab-pane>
    <el-tab-pane label="闲鱼" name="third">闲鱼</el-tab-pane>
    <el-tab-pane label="拼多多" name="fourth">拼多多</el-tab-pane>
    <el-tab-pane label="京东商城" name="fourth1">京东商城</el-tab-pane>
    <el-tab-pane label="苏宁易购" name="fourth2">苏宁易购</el-tab-pane>
    <el-tab-pane label="当当网" name="fourth3">当当网</el-tab-pane>
    <el-tab-pane label="唯品会" name="fourth4">唯品会</el-tab-pane>
    <el-tab-pane label="药房网" name="fourth5">药房网</el-tab-pane>
    <el-tab-pane label="1药城" name="fourth6">1药城</el-tab-pane>
  </el-tabs>
    <section class="seaerch-wrapper">
      <el-form :inline="true" size="mini" :model="formInline" class="demo-form-inline">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="店铺名称">
              <el-input v-model="formInline.user" placeholder="店铺名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="增改状态">
              <el-select v-model="formInline.region" placeholder="请选择">
                <el-option label="通知整改" value="shanghai"></el-option>
                <el-option label="已整改" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="最近通知时间">
              <el-date-picker
                v-model="formInline.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="所属平台">
              <el-input v-model="formInline.platform" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="13" style="text-align: right;">
            <el-form-item >
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
  <section class="content-warpper">
 <el-table
    ref="multipleTable"
    :data="tableData"
    tooltip-effect="dark"
    style="width: 100%"
    @selection-change="handleSelectionChange">
    <el-table-column
      type="selection"
      width="55">
    </el-table-column>
    <el-table-column
      label="日期"
      width="120">
      <template slot-scope="scope">{{ scope.row.date }}</template>
    </el-table-column>
    <el-table-column
      prop="name"
      label="姓名"
      width="120">
    </el-table-column>
    <el-table-column
      prop="address"
      label="地址"
      show-overflow-tooltip>
    </el-table-column>
  </el-table>
  <div style="margin-top: 20px">
    <el-button @click="toggleSelection([tableData[1], tableData[10]])">切换第二、第三行的选中状态</el-button>
    <el-button @click="toggleSelection()">取消选择</el-button>
  </div>
  </section>
  </div>
</template>

<script>
import  wrapperTable from '../../components/newtable/wrapperTable.vue'
export default {
  data() {
    return {
      activeName: 'second',
       tableData: [{
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-08',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-06',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-07',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }],
        multipleSelection: [],
    };
  },
  computed: {},
  created() {},
  mounted() {
      //请求模拟
      // let data={
      //     a:'1',
      //     b:'2'
      // }
      // this.$get('/api/v2/movie/top250',data)
      //     .then((response) => {
      //         console.log(response)
      //     })
      // this.$post('/login/login',data)
  },
  watch: {},
  methods: {
   handleClick(tab, event) {
        console.log(tab, event);
      }
  },
  components: {
    wrapperTable
  }
};
</script>

<style scoped lang="scss">
.seaerch-wrapper {
  padding: 24px 30px 0;
  margin-bottom: 10px;
  background-color: #fff;
}
.content-warpper{
    flex: 1;
    background-color: #fff;
    padding: 24px;
}
</style>
